import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  ButtonConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import {
  ButtonAppearance,
  FlowChartButton,
} from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { ButtonType } from 'common/builder/constants/ButtonType'
import EntityType from 'common/builder/constants/EntityType'
import { getButtonCaption } from 'common/builder/selectors/builder/buttonSelectors'

export const SmartLinkButtonCommonConverterRule: ConverterRule<
  IButton,
  FlowChartButton,
  ButtonConverterRulePayload
> = {
  predicate: (entity: IButton) =>
    entity?.entity === EntityType.BUTTON && 'isSmartLink' in entity && entity?.isSmartLink,

  convert: (entity, { state, builderId, fields }): FlowChartButton | null => {
    const buttonCaption = getButtonCaption(state, builderId, entity.id, { smartLink: true })
    const nextStepColor =
      entity.type === ButtonType.CONTENT
        ? sharedStyles.Colors.Tints.NEUTRAL[2]
        : sharedStyles.Colors.ACTIONS_CONNECTOR

    return new FlowChartButtonBuilder(entity.id)
      .withCaption(replaceFieldsInString(buttonCaption || entity.caption, fields))
      .withAppearance(ButtonAppearance.DEFAULT)
      .withIsInteractive(true)
      .withNextStep(new FlowChartNextStepBuilder(entity.id).withColor(nextStepColor).build())
      .build()
  },
}
